<script setup>
import { computed } from "vue";
import Multiselect from "vue-multiselect";
import { debounce } from "@/helpers/sharedHelper";

// eslint-disable-next-line
const props = defineProps({
  modelValue: Object,
  options: Array,
  label: String,
  trackBy: String,
  placeholder: String,
  disabled: {
    type: Boolean,
    default: false,
  },
});

// eslint-disable-next-line
const emit = defineEmits(["update:modelValue", "onSearch"]);

const internalValue = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

const safeOptions = computed(() =>
  Array.isArray(props.options) ? props.options : []
);

const onSelect = (e) => {
  internalValue.value = e;
};

const onRemove = () => {
  internalValue.value = null;
};

const onSearch = debounce((query) => {
  emit("onSearch", query);
}, 300);
</script>

<template>
  <div>
    <multiselect
      id="single-select-search"
      v-model="internalValue"
      :options="safeOptions"
      :show-labels="false"
      :placeholder="placeholder"
      :label="label"
      :track-by="trackBy"
      :disabled="disabled"
      @select="onSelect"
      @remove="onRemove"
      @search-change="onSearch($event)"
      class="custom-multiselect"
    />
  </div>
</template>

<style scoped>
@import "@/styles/multiselect.css";
</style>
